import dashboardRoutes from './dashboard.routes';

import dashboardController from './controllers/dashboard.controller';
import premierDashboardController from './controllers/premier.dashboard.controller';
import modalController from './controllers/modal.controller';
import uploadContractsController from './controllers/uploadContracts.controller';

import dashboardComponent from './components/dashboard.component';
import revenueDashboardComponent from './components/revenue.dashboard.component';
import statisticsDashboardComponent from './components/statistics.dashboard.component';
import premierDashboardComponent from './components/premier.dashboard.component';
import uploadContractsComponent from './components/uploadContracts.component';
import bestSellersDashboardComponent from './components/bestSellers.dashboard.component';

import dataApiService from './services/data.api.service';

let dashboardModule = angular.module('spabooker.dashboard', [])
    .config(dashboardRoutes)

    .controller('dashboardController', dashboardController)
    .controller('premierDashboardController', premierDashboardController)
    .controller('modalController', modalController)
    .controller('uploadContractsController', uploadContractsController)

    .component('dashboard', dashboardComponent)
    .component('revenueDashboard', revenueDashboardComponent)
    .component('statisticsDashboard', statisticsDashboardComponent)
    .component('premierDashboard', premierDashboardComponent)
    .component('uploadContracts', uploadContractsComponent)
    .component('bestSellersDashboard', bestSellersDashboardComponent)

    .factory('dataApiService', dataApiService);

export default dashboardModule.name;



// WEBPACK FOOTER //
// ./frontend/admin/app/modules/dashboard/index.js